import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import NProgress from 'nprogress'
import config from '../config'


NProgress.configure({ speed: 200, showSpinner:false });
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const AuthContainer = () => config.partnersConfiguration.login.type == 'custom' ? import('@/containers/CustomAuthContainer') : import('@/containers/AuthContainer')
// Views
const TransactionReport = () => import('@/views/reports/Transaction')
const TransactionsReport = () => import('@/views/reports/Transactions')

const DetailedTransactionsReport = () => import('@/views/reports/DetailedTransactions')
const FinanceReport = () => import('@/views/reports/FinanceReport')

const ReceivableTransactionsReport= () => import('@/views/reports/ReceivableTransactions')
const CurrentUserEdit = () => import ('@/views/account/Edit')


const Login = () => config.partnersConfiguration.login.type == 'custom' ? import('@/views/login/CustomLogin') : import('@/views/login/Login')

const PaymentsList = () => import ('@/views/partners/payments/List')
const PaymentsEdit = () => import ('@/views/partners/payments/Edit')
const PaymentsView = () => import ('@/views/partners/payments/View')

const PaymentLinkList = () => import ('@/views/partners/paymentLinks/List')
const PaymentLinkEdit = () => import ('@/views/partners/paymentLinks/Edit')


Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/reports/transactions',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        requiresAuth: true,
        title: 'Relatórios',
        roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
      },
      children: [
        {
          path: '/reports/transactions',
          name: 'Transações',
          component: TransactionsReport,         
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/detailedtransactions',
          name: 'Transações Detalhe',
          component: DetailedTransactionsReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Backoffice', 'Finance']
          }
        },
        {
          path: '/reports/statement',
          name: 'Relatório Financeiro',
          component: FinanceReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Finance', 'Seller', 'Salesperson']
          }
        },
        {
          path: '/reports/transaction/:id',
          props: true,
          name: 'Transação',
          component: TransactionReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance']
          }
        },
        {
          path: '/reports/receivabletransactions',
          name: 'Agenda Futura',
          component: ReceivableTransactionsReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance']
          }
        }        
      ]
    },
    {
      path: '/account',
      redirect: '/account/edit',
      name: 'Meu Cadastro',
      component: DefaultContainer,
      meta: {
        requiresAuth: true,
        title: 'Meu Cadastro',
        roles: ['Partner', 'Backoffice']
      },
      children: [
        {
          path: 'edit',
          name: 'Editar',
          component: CurrentUserEdit,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Backoffice']
          }
        }
      ]
    },
    {
      path: '/partners',
      redirect: '/partners/users',
      name: 'Parceiros',
      component: DefaultContainer,
      meta: {
        requiresAuth: true,
        label: 'Parceiros',
        roles: ['Partner']
      },
      children: [
      {
        path: 'payments',
        name: 'Pagamentos',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsList,
      },
      {
        path: 'payments/new',
        props: false,
        name: 'new_payment',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsEdit,
      },
      {
        path: 'payments/view/billpayment/:id',
        props: true,
        name: 'view_billpayment',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
      },
      {
        path: 'payments/view/withdraw/:id',
        props: true,
        name: 'view_withdraw',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
      },
      {
        path: 'payments/view/banktransfer/:id',
        props: true,
        name: 'view_banktransfer',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
      },
      {
        path: 'payments/view/pixtransfer/:id',
        props: true,
        name: 'view_pixtransfer',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
      },
      {
        path: 'paymentLinks',
        name: 'Links de Pagamento',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkList,
      },
      {
        path: 'paymentLinks/new',
        props: false,
        name: 'new_paymentlink',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkEdit,
      },
      {
        path: 'paymentLinks/edit/:id',
        props: true,
        name: 'edit_paymentlink',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkEdit,
      },            
    ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: AuthContainer,
      meta: {
        requiresAuth: false,
        title: 'Identificação'
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          props: route => ({
            rt: route.query.rt
          })
        }
      ]
    }
  ]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    if (store.getters.isAuthenticated) {
      
      const matchedRole = to.meta.roles.find(function(role) {
        return store.getters.currentUser.role === role
      })

      if(matchedRole) {
        next()
      }
      else {
        next({
          path: '/dashboard'
        })
      }
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



